import { isArray } from "lodash";
import { Calendar as ReactCalendar } from "react-calendar"
import { OnArgs, Value } from "react-calendar/dist/cjs/shared/types";
import './components/Calendar.css';
import { useState } from "react";
import { icons } from "assets/icons";

type Calendarprops = {
  selectRange?: boolean;
  onRangeChange?: (start: Date, end: Date) => void;
  onChange?: (value: Date) => void;
  value?: Date;
  values?: [Date, Date];
  minDate?: Date;
  maxDate?: Date
}

export const Calendar = (props: Calendarprops) => {

  const {
    selectRange = false,
    onRangeChange,
    onChange,
    value,
    values,
    minDate,
    maxDate,
  } = props;

  const handleChange = (dates: Value) => {
    if (!dates)
      return
    if (isArray(dates) && selectRange) {
      onRangeChange && dates[0] && dates[1] && onRangeChange(dates[0], dates[1]);
    }
    else {
      onChange && onChange(dates as Date)
    }
  }
  const [transitionDirection, setTransitionDirection] = useState('');
  const handleMonthChange = ({ action }: OnArgs) => {
    if (action === "prev") {
      setTransitionDirection('calendar-slide-exit');
    }
    if (action === "next") {
      setTransitionDirection('calendar-slide-enter');
    }
    setTimeout(() => {

      setTransitionDirection('')
    }, 300);
  };

  return (
    <ReactCalendar
      className={transitionDirection}
      onChange={handleChange}
      selectRange={selectRange}
      value={selectRange ? values : value}
      minDate={minDate}
      maxDate={maxDate}
      onActiveStartDateChange={handleMonthChange}
      nextLabel={<icons.ArrowRight2Icon aria-label="next" />}
      prevLabel={<icons.ArrowRight2Icon aria-label="previous" />}
    />
  );
}

